const IDLE_TIMEOUT = 30000;

class SensorReader {
  constructor() {
    // this.socket = new WebSocket("ws://node.kamilkazmierczak.usermd.net");
    // this.socket = new WebSocket("ws://localhost:9000");
    
    this.init();
    this.currentListenerId = 0;
    this.listeners = [];
    this.isConnectionAlive = false;

    this.closeWhenIdleTimer = null;

    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this), false);
    window.SR = this;
  }

  isPageVisible() {
    return document.visibilityState === "visible";
  }

  handleVisibilityChange() {
    const isVisible = this.isPageVisible();
    console.log('vis change, vis=', isVisible)
  
    if (isVisible) {
      clearTimeout(this.closeWhenIdleTimer);
    } else {
      this.closeWhenIdleTimer = setTimeout(() => {
        console.log('app idle 30s, closing connection');
        this.socket.close();
      }, IDLE_TIMEOUT);
    }

    if (!this.isConnectionAlive && isVisible) {
      console.log('reconnecting websocket...')
      this.init();
    }
  }

  init() {
    this.socket = new WebSocket("wss://skynet.kamilkazmierczak.usermd.net"); 
    this.onSocketOpen();
    this.onSocketMessage();
    this.onSocketError();
    this.onSocketClose();
  }

  removeListener(listenerId) {
    const index = this.listeners.findIndex((listener) => listener.id === listenerId);

    if (index > -1) {
      this.listeners.splice(index, 1);
    }
  }

  registerListener(actions) {
    const listenerId = this.currentListenerId;

    this.listeners.push({
      actions,
      id: listenerId
    })

    this.currentListenerId++;

    return () => this.removeListener(listenerId);
  }

  notifyListeners(data, action) {
    this.listeners.forEach(listener => {
      listener.actions[action](data);
    })
  }

  onSocketOpen() {
    this.socket.onopen = (e) => {
      console.warn("[open] Connection established");
      this.isConnectionAlive = true;
    };
  }

  onSocketMessage() {
    this.socket.onmessage = (event) => {
      const data = JSON.parse(event.data);

      this.notifyListeners(data, 'onMessage');
    };
  }

  onSocketError() {
    this.socket.onerror = (error) => {
      console.error(`[error] ${error.message}`);
    };
  }

  onSocketClose() {
    this.socket.onclose = (event) => {
      this.isConnectionAlive = false;
      this.notifyListeners(null, 'onDeath');

      if (event.wasClean) {
        console.log(`[close] Connection closed cleanly, code=${event.code} reason=${event.reason}`);
      } else {
        console.error('[close] Connection died');
        console.log('afterDead visibile=', this.isPageVisible())

        if (this.isPageVisible()) {
          console.log('reconnecting websocket... (when visible)')
          this.init();
        }
      }
    };
  }
}

export default new SensorReader();